import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

const KEYS = ["people", "friendRequests", "friends", "notifications", "followers", "joined"];
const first = (n) => n.split(" ")[0];

export const useFriendActions = () => {
  const qc = useQueryClient();
  const run = async (fn, ok) => {
    try {
      const r = await fn();
      toast.success(ok(r));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Something went wrong");
    }
    KEYS.forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
  };
  return {
    add: (p) => run(() => api.sendRequest(p.user_id), (r) => (r.relation === "friend" ? `You and ${first(p.name)} are now friends` : `Friend request sent to ${first(p.name)}`)),
    accept: (p) => run(() => api.respondRequest(p.user_id, true), () => `You and ${first(p.name)} are now friends`),
    decline: (p) => run(() => api.respondRequest(p.user_id, false), () => "Request declined"),
    cancel: (p) => run(() => api.cancelRequest(p.user_id), () => "Request cancelled"),
  };
};
